














































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import DescriptionEditor from "./DescriptionEditor.vue";

@Component({
    components: {DescriptionEditor}
})
export default class SimpleMenuDescriptionEditor extends Vue {

    @Model('updated:text')
    value!: string;

    @Prop({type: Boolean, default: false})
    textArea: boolean;

    @Prop({default: false})
    disabled: Boolean;

    @Prop()
    innerClass: string;

    @Prop()
    show!: boolean;

    private internalValue = '';
    private open = false;

    mounted() {
        this.internalValue = this.value;
        if (this.show) {
            setTimeout(() => this.open = this.show, 200)
        }
    }

    @Watch('open')
    onOpenChange(newVal: boolean, oldVal: boolean) {
        if (!newVal && oldVal) {
            this.closedMenu();
        } else if (newVal) {
            this.internalValue = this.value;
            this.$emit('open')
        }
    }

    @Watch('show')
    onShowChange(newVal: boolean) {
        this.open = newVal;
    }

    private selectAll(e: Event) {
        if (e.target) {
            (e.target as HTMLInputElement).select();
        }
    }

    @Emit('change')
    @Emit('updated:text')
    private updateValue(newValue: string) {
        this.open = false;
        return newValue;
    }

    @Emit('closed')
    private closedMenu() {
        return this.internalValue;
    }

    @Emit('closed')
    @Emit('save')
    @Emit('updated:text')
    private save() {
        this.open = false;
        return this.internalValue;
    }

    @Emit('cancel')
    private cancel() {
        this.internalValue = this.value;
        this.open = false;
    }

    private numOfRows(dataField: any) {
        if (dataField && dataField.length) {
            return Math.ceil(dataField.length / 60);
        }
        return 1;
    }

}

